var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 40,
    viewBox: "0 0 34 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4215 0.969005C21.4215 0.961664 21.4284 0.954322 21.4284 0.946982C21.4284 0.425774 19.5794 0 17.3044 0C15.0705 0 13.256 0.411093 13.1872 0.917619L2.25866 22.0522C-6.55657 42.1047 33.8209 44.0237 33.8209 26.4348L21.4215 0.969005Z",
    fill: "url(#paint0_linear_610_173)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3044 25.995L30.6435 27.2043C30.4621 28.0531 30.1396 28.9019 29.6558 29.7657C29.5886 29.8634 29.5416 29.9686 29.4677 30.0737C28.1373 31.929 26.2424 33.3863 23.7966 34.3252C22.5267 34.7684 21.0821 35.0914 19.4829 35.3242C19.2074 35.3543 18.9386 35.3993 18.6632 35.4144H17.3798H16.0964C15.8142 35.3993 15.5454 35.3543 15.2767 35.3242C13.6775 35.0989 12.2261 34.7684 10.9629 34.3252C8.51712 33.3863 6.61558 31.929 5.29189 30.0737C5.21798 29.9761 5.17094 29.8709 5.10375 29.7657C4.13618 28.0456 3.80022 26.348 4.01524 24.688C4.24369 22.9378 4.94921 21.3679 6.05116 19.9558L6.02429 19.9708C7.05233 18.7088 8.3693 17.7173 9.98192 16.9587C12.0918 15.9597 14.3293 15.4564 16.8221 15.3662H18.2264L20.343 15.5991C21.8884 15.847 23.3599 16.2902 24.7844 16.9587C26.397 17.7173 27.714 18.7088 28.742 19.9708L28.7151 19.9558C28.8898 20.1811 29.0578 20.414 29.2123 20.6468L10.1499 29.3L10.1566 29.3301C10.7546 29.8934 11.5206 30.3366 12.4949 30.6371L31.8396 21.8862C31.8127 21.8486 31.7858 21.8111 31.7657 21.766C31.685 21.6233 31.6178 21.4881 31.5305 21.3529L31.4902 21.3304C30.0254 19.122 27.9088 17.4845 25.1808 16.2526C23.5749 15.5315 21.9354 15.0733 20.2153 14.8329L18.1928 14.6451L16.8355 14.6527C14.215 14.7278 11.8431 15.231 9.56532 16.2601C6.83731 17.492 4.72075 19.1295 3.25596 21.3379L3.21565 21.3604C3.1283 21.5031 3.0611 21.6383 2.98047 21.7735C2.92672 21.8562 2.86624 21.9463 2.81249 22.0289C2.75202 22.1341 2.7117 22.2317 2.65795 22.3369C2.61764 22.412 2.57733 22.4946 2.53701 22.5698C0.978149 25.6194 0.877355 28.8343 2.82593 32.0342C5.11047 35.7975 9.33015 38.2086 15.1759 38.7044C15.2363 38.7119 15.2968 38.7119 15.3573 38.7119C15.915 38.757 16.4727 38.802 17.0505 38.8096C17.158 38.8096 17.2588 38.7945 17.3731 38.7945C17.4806 38.7945 17.5814 38.8096 17.6956 38.8096C18.2734 38.802 18.8311 38.757 19.3888 38.7119C19.4493 38.7044 19.5098 38.7044 19.5702 38.7044C25.416 38.2162 29.6357 35.7975 31.9202 32.0342C33.1431 30.0061 33.5597 27.978 33.3044 25.995Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.9708,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_610_173",
    x1: 18.4507,
    y1: -10.7805,
    x2: 17.3387,
    y2: 25.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2259,
    stopColor: "white",
    stopOpacity: 0.7741
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4744,
    stopColor: "white",
    stopOpacity: 0.5256
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6954,
    stopColor: "white",
    stopOpacity: 0.3046
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "white",
    stopOpacity: 0.1218
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/active.075e2bbe7adc0cc2be0ba7ec64e86992.svg";
export { ForwardRef as ReactComponent };